import { Stack } from '@mantine/core';
import { DispatchStep } from '@/types/automationSteps.ts';
import StepCommonFields from '@/pages/Editor/components/SharedFields/StepCommonFields.tsx';
import IntegrationFieldsContainer from '@/pages/Editor/components/SharedFields/IntegrationFields/IntegrationFieldsContainer.tsx';
import OutputNameField from '@/pages/Editor/components/SharedFields/OutputNameField.tsx';
import StepAdvancedConfigFields from '@/pages/Editor/components/SharedFields/StepAdvancedConfigFields.tsx';
import RuntimeOutputNameField from '@/pages/Editor/components/SharedFields/RuntimeOutputNameField.tsx';

type props = {
  step: DispatchStep;
};

export function DispatchForm({ step }: props) {
  return (
    <Stack gap="md">
      <StepCommonFields step={step} nameLabel={'Step Name'} />
      <IntegrationFieldsContainer step={step} />
      <OutputNameField step={step} />
      <RuntimeOutputNameField step={step} />
      <StepAdvancedConfigFields step={step} />
    </Stack>
  );
}
